export default class CountryModel {
  constructor(obj) {
    obj = obj || {};
    this.code = obj.code;
    this.name = obj.name;
  }
}